import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'typeface-roboto/index.css';
import './assets/fonts/font.css'

Vue.config.productionTip = false

import moment from 'moment';

moment.locale('it');
Vue.prototype.moment = moment;
import lodash from 'lodash';

Vue.prototype._ = lodash;
import keycloakJs from 'keycloak-js';

Vue.prototype.keycloakJs = keycloakJs;
import axios from 'axios';

Vue.prototype.axios = axios;

import VueGtag from "vue-gtag";

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);


let GtagUsed = false;
if (!isLocalhost) {
    window.addEventListener('CookiebotOnAccept', function () {
        console.log('CookiebotOnAccept');
        if (Cookiebot.consent.statistics) {
            GtagUsed = true;
            Vue.use(VueGtag, {
                config: {id: store.getters['config/google_analytics_tracking_id']}
            });
        }
    }, false);
    window.addEventListener('CookiebotOnDecline', function () {
        console.log('CookiebotOnDecline');
        if (GtagUsed === true) {
            if (Cookiebot.consent.statistics !== true) {
                location.reload();
            }
        }

    }, false);
}

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
 